import { motion } from "framer-motion";
import Link from "next/link";
import { Text } from "../Text";

export type LinkedInButtonProps = {
  url: string;
  animate?: 'rest' | 'hover';
}

const textAnimationVariants = {
  rest: {
    width: 0,
    marginLeft: 0,
    clipPath: 'inset(0 100% 0 0)',
  },
  hover: {
    width: 'auto',
    marginLeft: '20px',
    clipPath: 'inset(0 0 0 0)',
  },
};

const LinkedInLogoSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14 14H11.5344V9.80049C11.5344 8.6491 11.0969 8.00566 10.1855 8.00566C9.19414 8.00566 8.67617 8.67526 8.67617 9.80049V14H6.3V6H8.67617V7.0776C8.67617 7.0776 9.39063 5.75559 11.0883 5.75559C12.7852 5.75559 14 6.7918 14 8.9349V14ZM3.46523 4.95246C2.65586 4.95246 2 4.29146 2 3.47623C2 2.66101 2.65586 2 3.46523 2C4.27461 2 4.93008 2.66101 4.93008 3.47623C4.93008 4.29146 4.27461 4.95246 3.46523 4.95246ZM2.23828 14H4.71602V6H2.23828V14Z" fill="white" />
    </svg>
  );
};

export const LinkedInButton = ({ url, animate }: LinkedInButtonProps) => {
  return (
    <Link href={url} target="_blank">
      <motion.button
        className="flex items-center"
        initial="rest"
        animate={animate}
        whileHover={animate === undefined ? 'hover' : undefined}>
        <div className="p-[10px] bg-[#069] rounded-full">
          <LinkedInLogoSvg />
        </div>
        <motion.div
          variants={textAnimationVariants}>
          <Text type="p2" className="text-primary">LinkedIn</Text>
        </motion.div>
      </motion.button>
    </Link>
  );
};
